import { accessWays } from "@/mocks/home";

export default function AccessWays() {
  return (
    <section id="ways" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-10 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">HOW TO GET</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              三种获取方式
            </h2>
          </div>
          <p className="text-sm md:text-base leading-7 text-foreground-600 max-w-md">
            没有绝对最好的方式，只有适合你现在状态的那种。先看耐心成本，再决定用哪一种。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {accessWays.map((way, i) => (
            <article
              key={way.id}
              className="group flex flex-col h-full rounded-lg border border-foreground-950/12 bg-background-50 p-5 md:p-7 hover:border-primary-400 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={`${way.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-3xl font-bold text-foreground-200">
                  0{i + 1}
                </span>
              </div>

              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
                {way.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-foreground-600 flex-1">
                {way.summary}
              </p>

              <ul className="mt-5 pt-5 border-t border-foreground-950/10 space-y-2.5">
                {way.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-accent-600 mt-0.5"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}